import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import "font-awesome/css/font-awesome.css";
import VueHtml2Canvas from "vue-html2canvas";
import moment from "moment";
import VBodyScrollLock from "v-body-scroll-lock";

Vue.use(VueHtml2Canvas);
Vue.prototype.moment = moment;
Vue.config.productionTip = false;
Vue.use(VBodyScrollLock);

// MSW 啟動必須在 vue app 啟動前，才能確保攔截所有 API 包含初始
async function startApp() {
  // 只在開發環境且啟用 mock 時才載入 MSW
  if (
    process.env.NODE_ENV === "development" &&
    process.env.VUE_APP_ENABLE_MOCK === "true"
  ) {
    const { startMockWorker } = await import("./mocks/browser");
    await startMockWorker();
  }

  // 啟動 Vue 應用
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
}

startApp();
